import * as XLSX from 'xlsx';

export const CreateExcelFile = (data: any[]) => {
  const worksheet = XLSX.utils.json_to_sheet(data);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet 1');
  const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
  const excelData = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  const excelUrl = URL.createObjectURL(excelData);

  const link = document.createElement('a');
  link.href = excelUrl;
  link.download = 'data.xlsx';
  link.click();

  URL.revokeObjectURL(excelUrl);
};